// MyWishlist.jsx
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { WishlistServices } from "../../services/WishlistServices";
import { CartServices } from "../../services/CartServices";

const API_BASE = "https://api.ifjona.com";

const toNumber   = (val) => { const n = Number(String(val ?? "").replace(/[^\d.]/g, "")); return Number.isFinite(n) ? n : 0; };
const getCurrencySymbol = (row) => {
  if (row?.resolved_price?.currency_symbol) {
    return row.resolved_price.currency_symbol;
  }

  if (row?.location?.currency?.symbol) {
    return row.location.currency.symbol;
  }

  if (row?.locationProductPrice?.location?.currency?.symbol) {
    return row.locationProductPrice.location.currency.symbol;
  }

  if (row?.productInfoLocationPrice?.location?.currency?.symbol) {
    return row.productInfoLocationPrice.location.currency.symbol;
  }

  return "$";
};

const money = (amount, symbol = "$") =>
  `${symbol}${Number(amount || 0).toFixed(2)}`;
const toImageUrl = (value) => {
  if (!value) return null;
  const s = String(value).trim();
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("/storage/")) return `${API_BASE}${s}`;
  if (s.startsWith("storage/"))  return `${API_BASE}/${s}`;
  return `${API_BASE}/storage/${s.replace(/^\/+/, "").replace(/^storage\//, "")}`;
};

const resolveImage      = (row) => toImageUrl((row?.product_info || row?.productInfo)?.image || row?.product?.image) || "/assets/images/thumbs/product-thumb-1.png";
const resolveTitle      = (row) => row?.product?.title || "Product";
const resolveDetailsUrl = (row) => row?.product?.id ? `/product-details/${row.product.id}` : "/product-details";
const resolveCategory   = (row) => row?.product?.category?.name || row?.product?.category_name || "";
const resolveUnitPrice = (row) => {
  if (row?.resolved_price?.unit_price) {
    return toNumber(row.resolved_price.unit_price);
  }

  const info = row?.product_info || row?.productInfo;
  const product = row?.product;

  if (
    row?.locationProductPrice?.flash_sales_price != null &&
    row.locationProductPrice.flash_sales_price !== ""
  ) {
    return toNumber(row.locationProductPrice.flash_sales_price);
  }

  if (
    row?.productInfoLocationPrice?.flash_sale_price != null &&
    row.productInfoLocationPrice.flash_sale_price !== ""
  ) {
    return toNumber(row.productInfoLocationPrice.flash_sale_price);
  }

  if (info?.flash_sale_price != null && info.flash_sale_price !== "") {
    return toNumber(info.flash_sale_price);
  }

  if (product?.flash_sale_price != null && product.flash_sale_price !== "") {
    return toNumber(product.flash_sale_price);
  }

  const override =
    row?.productInfoLocationPrice?.current_price_override ??
    info?.current_price_override ??
    null;

  if (override !== null && override !== "") {
    return toNumber(override);
  }

  if (row?.locationProductPrice?.base_current_price != null) {
    return toNumber(row.locationProductPrice.base_current_price);
  }

  return toNumber(product?.base_current_price ?? 0);
};
const hasFlashSale = (row) => {
  if (row?.resolved_price?.is_flash_sale) return true;

  if (
    row?.locationProductPrice?.flash_sales_price != null &&
    row.locationProductPrice.flash_sales_price !== ""
  ) {
    return true;
  }

  if (
    row?.productInfoLocationPrice?.flash_sale_price != null &&
    row.productInfoLocationPrice.flash_sale_price !== ""
  ) {
    return true;
  }

  const info = row?.product_info || row?.productInfo;
  const product = row?.product;

  if (info?.flash_sale_price != null && info.flash_sale_price !== "") return true;
  if (product?.flash_sale_price != null && product.flash_sale_price !== "") return true;

  return false;
};


const CSS_WISH = `
  :root {
    --g-primary: #299e60; --g-light: #f3faf2;
    --g-border: #c4e8d1;  --g-hover: #228a52; --g-text: #1a5c3a;
  }
  .mw-cb        { accent-color:var(--g-primary); width:17px; height:17px; cursor:pointer; flex-shrink:0; }
  .mw-sel-row   { background:var(--g-light) !important; }
  .mw-ptitle    { font-size:13px; font-weight:700; color:#1d2939; text-decoration:none; line-height:1.4; }
  .mw-ptitle:hover { color:var(--g-primary); }
  .mw-cat       { font-size:10px; font-weight:700; color:#b0b8c8; text-transform:uppercase; letter-spacing:.6px; }
  .mw-xbtn      { background:none; border:none; cursor:pointer; color:#d0d5dd; padding:5px; border-radius:6px; display:flex; align-items:center; transition:color .15s,background .15s; }
  .mw-xbtn:hover { color:#d94040; background:#fff5f5; }

  .mw-toolbar   { background:var(--g-light); border:1px solid var(--g-border); border-radius:8px; padding:10px 16px; margin-bottom:14px; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px; }
  .mw-sel-badge { background:#fff; color:var(--g-primary); border:1px solid var(--g-border); border-radius:20px; font-size:11px; font-weight:700; padding:2px 10px; }
  .mw-rem-sel   { background:#fff5f5; border:1px solid #fcc; border-radius:6px; padding:5px 12px; font-size:12px; font-weight:700; color:#d94040; cursor:pointer; }
  .mw-rem-sel:hover { background:#ffe0e0; }

  .mw-add-sel-btn {
    background:var(--g-primary); color:#fff; border:none; border-radius:8px;
    padding:6px 14px; font-size:12px; font-weight:700; cursor:pointer;
    display:flex; align-items:center; gap:6px; transition:background .15s;
  }
  .mw-add-sel-btn:hover { background:var(--g-hover); }

  /* ── Desktop table ── */
  .mw-thumb   { width:64px; height:64px; object-fit:cover; border-radius:8px; }
  .mw-trow td { padding:12px 10px; border-bottom:1px solid #f5f5f5; vertical-align:middle; }
  .mw-trow:last-child td { border-bottom:none; }
  .mw-trow.mw-sel-row td { background:var(--g-light); }
  .mw-price   { font-size:13px; font-weight:700; color:#475467; white-space:nowrap; }

  .mw-stock     { font-size:11px; font-weight:700; padding:3px 10px; border-radius:20px; white-space:nowrap; }
  .mw-stock.in  { background:var(--g-light); color:var(--g-text); border:1px solid var(--g-border); }
  .mw-stock.out { background:#fff5f5; color:#d94040; border:1px solid #fcc; }

  .mw-added { background:var(--g-light); color:var(--g-text); border:1px solid var(--g-border); border-radius:6px; padding:5px 14px; font-size:12px; font-weight:700; cursor:default; display:inline-flex; align-items:center; gap:5px; }

  .mw-cart-btn {
    background:var(--g-primary); color:#fff; border:none; border-radius:8px;
    padding:7px 16px; font-size:12px; font-weight:700; cursor:pointer;
    display:inline-flex; align-items:center; gap:6px;
    transition:background .15s; white-space:nowrap;
  }
  .mw-cart-btn:hover { background:var(--g-hover); }

  /* ── Mobile cards ── */
  .mw-mcard { border:1px solid #ececec; border-radius:12px; margin-bottom:10px; overflow:hidden; }
  .mw-mcard.mw-sel-row { background:var(--g-light); border-color:var(--g-border); }
  .mw-m-top    { display:flex; align-items:flex-start; gap:12px; padding:12px 12px 8px; }
  .mw-mimg     { width:72px; height:72px; object-fit:cover; border-radius:10px; border:1px solid #ececec; flex-shrink:0; }
  .mw-m-info   { flex:1; min-width:0; }
  .mw-m-title-row { display:flex; justify-content:space-between; align-items:flex-start; gap:8px; margin-bottom:4px; }
  .mw-m-bottom { display:flex; align-items:center; justify-content:space-between; padding:8px 12px 12px; border-top:1px solid #f5f5f5; background:var(--g-light); gap:8px; flex-wrap:wrap; }
  .mw-m-pricebox { display:flex; flex-direction:column; gap:2px; }
  .mw-m-plabel   { font-size:10px; font-weight:700; color:#b0b8c8; text-transform:uppercase; letter-spacing:.5px; }
  .mw-m-pval     { font-size:13px; font-weight:700; color:#475467; }

  /* ── Summary bar ── */
  .mw-summary {
    background:var(--g-light); border:1px solid var(--g-border);
    border-radius:10px; padding:14px 18px; margin-top:16px;
    display:flex; align-items:center; justify-content:space-between;
    flex-wrap:wrap; gap:8px; font-size:13px;
  }
  .mw-summary-total { color:var(--g-primary); font-weight:800; font-size:15px; font-family:'Fira Code',monospace; }
`;

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
  </svg>
);

const CartIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
  </svg>
);

/**
 * Props:
 *  - onBack : () => void
 */
const MyWishlist = ({ onBack }) => {
  const navigate = useNavigate();
  const wishlistRootRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      wishlistRootRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }, []);

  const [loading, setLoading] = useState(false);
  const [rows, setRows]               = useState([]);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [addedIds, setAddedIds]       = useState(new Set());

  const loadWishlist = useCallback(async () => {
    setLoading(true);
    try {
      const items = await WishlistServices.getWishlist();
      const arr = Array.isArray(items) ? items : [];
      setRows(arr);
      setSelectedIds(prev =>
        prev.size === 0 && arr.length > 0
          ? new Set(arr.map(r => String(r.id)))
          : prev
      );
    } catch (err) {
      console.error("Failed to load wishlist:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadWishlist();
    const evts = ["wishlist_updated", "customer_logged_in"];
    evts.forEach(e => window.addEventListener(e, loadWishlist));
    return () => evts.forEach(e => window.removeEventListener(e, loadWishlist));
  }, [loadWishlist]);

  const removeItem = async (id) => {
    try {
      await WishlistServices.remove(id);
      setSelectedIds(prev => { const n = new Set(prev); n.delete(String(id)); return n; });
      setAddedIds(prev => { const n = new Set(prev); n.delete(String(id)); return n; });
      await loadWishlist();
      window.dispatchEvent(new Event("wishlist_updated"));
    } catch (err) { console.error("Remove wishlist failed:", err); }
  };

  const removeSelected = async () => {
    for (const id of selectedIds) { try { await WishlistServices.remove(id); } catch {} }
    setSelectedIds(new Set());
    await loadWishlist();
    window.dispatchEvent(new Event("wishlist_updated"));
  };

  const addToCart = async (row) => {
    try {
      const payload = {
        product_id: row?.product_id ?? row?.product?.id ?? null,
        product_info_id: row?.product_info_id ?? row?.product_info?.id ?? null,
        quantity: 1,
        location_product_price_id:
          row?.location_product_price_id ??
          row?.location_product_price?.id ??
          null,
        product_info_location_price_id:
          row?.product_info_location_price_id ??
          row?.product_info_location_price?.id ??
          null,
      };

      await CartServices.add(payload);

      setAddedIds((prev) => new Set([...prev, String(row.id)]));
      window.dispatchEvent(new Event("cart_updated"));
    } catch (err) {
      console.error("Add to cart failed:", err);
    }
  };

  const addSelectedToCart = async () => {
    const selected = rows.filter(r => selectedIds.has(String(r.id)));
    for (const row of selected) { try { await addToCart(row); } catch {} }
  };

  const toggleSelect = (id) =>
    setSelectedIds(prev => { const n = new Set(prev); n.has(String(id)) ? n.delete(String(id)) : n.add(String(id)); return n; });

  const allSelected  = rows.length > 0 && rows.every(r => selectedIds.has(String(r.id)));
  const someSelected = selectedIds.size > 0;
  const toggleAll    = () => setSelectedIds(allSelected ? new Set() : new Set(rows.map(r => String(r.id))));

  const totalValue = useMemo(() => rows.reduce((s, r) => s + resolveUnitPrice(r), 0), [rows]);

  const StockBadge = ({ row }) => {
    const inStock = row?.product?.stock_quantity > 0 || row?.product?.in_stock !== false;
    return <span className={`mw-stock ${inStock ? "in" : "out"}`}>{inStock ? "✓ In Stock" : "Out of Stock"}</span>;
  };

  const AddBtn = ({ row }) => {
    const isAdded = addedIds.has(String(row.id));
    return isAdded
      ? <span className="mw-added">✓ Added</span>
      : <button type="button" className="mw-cart-btn" onClick={() => addToCart(row)}>
          <CartIcon /> Add to Cart
        </button>;
  };

  return (
    <>
      <style>{CSS_WISH}</style>

      {/* ── Topbar ── */}
      <div className="ap-topbar" ref={wishlistRootRef}>
        <span className="ap-topbar-title">My Wishlist</span>
        <div className="ap-topbar-right">
          <button className="ap-btn-sm outline" onClick={loadWishlist} disabled={loading}>
            <i className="ph ph-arrows-clockwise" />
            {loading ? "Loading…" : "Refresh"}
          </button>
        </div>
      </div>

      {/* ── Body ── */}
      <div className="ap-body">

        {/* Back */}
        <div style={{ marginBottom: 20 }}>
          <button
            onClick={onBack}
            style={{
              background: "none", border: "none", cursor: "pointer",
              display: "inline-flex", alignItems: "center", gap: 6,
              fontSize: 13, fontWeight: 600, color: "#6b7280",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}
          >
            <i className="ph ph-arrow-left" style={{ fontSize: 15 }} />
            Back to Overview
          </button>
        </div>

        <div className="ap-section">
          <div className="ap-section-hd">
            <div>
              <div className="ap-section-title">Saved Items</div>
              <div className="ap-section-sub">
                {rows.length} item{rows.length !== 1 ? "s" : ""} in your wishlist
              </div>
            </div>
            {rows.length > 0 && someSelected && (
              <button className="mw-add-sel-btn" onClick={addSelectedToCart}>
                <CartIcon /> Add Selected to Cart
              </button>
            )}
          </div>

          <div className="ap-section-bd">

            {/* Loading */}
            {loading && (
              <div className="ap-spinner">
                <div className="ap-spin-ring" />
                Loading your wishlist…
              </div>
            )}

            {/* Empty */}
            {!loading && rows.length === 0 && (
              <div style={{ textAlign: "center", padding: "48px 24px" }}>
                <div style={{ fontSize: 44, marginBottom: 12 }}>🤍</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#374151", marginBottom: 6 }}>
                  Your wishlist is empty
                </div>
                <div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 20 }}>
                  Save products you love and come back to them later.
                </div>
                <Link to="/shop"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 6,
                    padding: "10px 22px", borderRadius: 9,
                    background: "#111827", color: "#fff",
                    fontSize: 13, fontWeight: 700, textDecoration: "none",
                  }}
                >
                  <i className="ph ph-storefront" /> Go to Shop
                </Link>
              </div>
            )}

            {!loading && rows.length > 0 && (
              <>
                {/* Toolbar */}
                <div className="mw-toolbar">
                  <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 700, color: "#344054", cursor: "pointer", userSelect: "none", marginBottom: 0 }}>
                      <input type="checkbox" className="mw-cb" checked={allSelected} onChange={toggleAll} />
                      {allSelected ? "Deselect All" : "Select All"}
                    </label>
                    {someSelected && (
                      <span className="mw-sel-badge">{selectedIds.size} of {rows.length} selected</span>
                    )}
                  </div>
                  {selectedIds.size > 1 && (
                    <button className="mw-rem-sel" onClick={removeSelected}>
                      Remove Selected ({selectedIds.size})
                    </button>
                  )}
                </div>

                {/* ── Desktop Table ── */}
                <div className="d-none d-md-block" style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {rows.map((row, idx) => {
                        const id = String(row.id), sel = selectedIds.has(id);
                        const unitPrice = resolveUnitPrice(row);
                        const isFlash = hasFlashSale(row);
                        const currency = getCurrencySymbol(row);
                        return (
                          <tr key={`${id}-${idx}`} className={`mw-trow${sel ? " mw-sel-row" : ""}`}>
                            <td style={{ width: 32 }}>
                              <input type="checkbox" className="mw-cb" checked={sel} onChange={() => toggleSelect(id)} />
                            </td>
                            <td>
                              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                                <Link to={resolveDetailsUrl(row)} style={{ flexShrink: 0, display: "block", width: 64, height: 64, borderRadius: 8, overflow: "hidden", border: "1px solid #f0f0f0" }}>
                                  <img src={resolveImage(row)} alt={resolveTitle(row)} className="mw-thumb"
                                    onError={e => { e.currentTarget.src = "/assets/images/thumbs/product-thumb-1.png"; }} />
                                </Link>
                                <div>
                                  <Link to={resolveDetailsUrl(row)} className="mw-ptitle" style={{ display: "block", marginBottom: 4 }}>
                                    {resolveTitle(row)}
                                  </Link>
                                  {resolveCategory(row) && <span className="mw-cat">{resolveCategory(row)}</span>}
                                </div>
                              </div>
                            </td>
                            <td className={`mw-price${isFlash ? " text-danger" : ""}`}>
                              {money(unitPrice, currency)}
                            </td>
                            <td><StockBadge row={row} /></td>
                            <td><AddBtn row={row} /></td>
                            <td style={{ width: 40 }}>
                              <button className="mw-xbtn" onClick={() => removeItem(row.id)} title="Remove">
                                <TrashIcon />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* ── Mobile Cards ── */}
                <div className="d-md-none">
                  {rows.map((row, idx) => {
                    const unitPrice = resolveUnitPrice(row);
                    const isFlash = hasFlashSale(row);
                    const currency = getCurrencySymbol(row);
                    const id = String(row.id), sel = selectedIds.has(id);
                    return (
                      <div key={`${id}-${idx}`} className={`mw-mcard${sel ? " mw-sel-row" : ""}`}>
                        <div className="mw-m-top">
                          <input type="checkbox" className="mw-cb" style={{ marginTop: 4 }}
                            checked={sel} onChange={() => toggleSelect(id)} />
                          <Link to={resolveDetailsUrl(row)} style={{ flexShrink: 0 }}>
                            <img src={resolveImage(row)} alt={resolveTitle(row)} className="mw-mimg"
                              onError={e => { e.currentTarget.src = "/assets/images/thumbs/product-thumb-1.png"; }} />
                          </Link>
                          <div className="mw-m-info">
                            <div className="mw-m-title-row">
                              <Link to={resolveDetailsUrl(row)} className="mw-ptitle">{resolveTitle(row)}</Link>
                              <button className="mw-xbtn" onClick={() => removeItem(row.id)} title="Remove">
                                <TrashIcon />
                              </button>
                            </div>
                            {resolveCategory(row) && <span className="mw-cat">{resolveCategory(row)}</span>}
                          </div>
                        </div>
                        <div className="mw-m-bottom">
                          <div className="mw-m-pricebox">
                            <span className="mw-m-plabel">Price</span>
                            <span className={`mw-m-pval${isFlash ? " text-danger" : ""}`}>
                              {money(unitPrice, currency)}
                            </span>
                          </div>
                          <StockBadge row={row} />
                          <AddBtn row={row} />
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Summary bar */}
                <div className="mw-summary">
                  <span style={{ color: "#6b7280", fontWeight: 600 }}>
                    {rows.length} {rows.length === 1 ? "item" : "items"} saved
                  </span>
                  <span style={{ fontWeight: 700, color: "#1d2939" }}>
                    Total value: <span className="mw-summary-total">{money(totalValue)}</span>
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyWishlist;